import React from 'react';
import { useNavigate } from 'react-router-dom';
import './BuyNewTaxiSiderHomePage.css';
import Rav4 from '../../Pages/NewTaxiPage/Rav4.png';
import E220 from '../../Pages/NewTaxiPage/e220.png';
import Elantra from '../../Pages/NewTaxiPage/Elantra.png';
import YarisCross from '../../Pages/NewTaxiPage/YarisCross.png';

const taxis = [
  { name: 'טויוטה ראב4', image: Rav4 },
  { name: 'יונדאי אלנטרה', image: Elantra },
  { name: 'מרצדס E220', image: E220 },
  { name: 'יאריס קרוס', image: YarisCross },
];

const BuyNewTaxiSiderHomePage = () => {
  const navigate = useNavigate();

  return (
    <div className="BuyNewTaxiSiderHomePage-container">
      <h2 className="BuyNewTaxiSiderHomePage-title">רוצה להתחדש במונית חדשה?</h2>
      <p className="BuyNewTaxiSiderHomePage-description">
        מוניות חדשות מציעות נוחות, חיסכון, ואמינות מירבית. עם אפשרויות מימון, טרייד אין וזכויות ציבוריות – זו ההזדמנות שלך לשדרג.
      </p>

      <div className="BuyNewTaxiSiderHomePage-images">
        {taxis.map((taxi, index) => (
          <div className="BuyNewTaxiSiderHomePage-imageWrapper" key={index}>
            <img src={taxi.image} alt={taxi.name} />
            <p className="BuyNewTaxiSiderHomePage-imageTitle">{taxi.name}</p>
          </div>
        ))}
      </div>

      <button className="hero-button" onClick={() => navigate('/NewTaxi')}>
        לעמוד המוניות החדשות
      </button>
    </div>
  );
};

export default BuyNewTaxiSiderHomePage;
